<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <v-row v-if="groupPriceModel">
        <v-col :sm="nextPriceModel ? 9 : 12" cols="12">
          <h2 :class="$vuetify.breakpoint.xsOnly ? 'pt-10' : ''">{{ dialogTitle }}</h2>

          <p>Liebe:r
            <fin-current-user-name/>
            <span>,</span>
          </p>

          <p
            v-if="restrictionType === featureRestrictions.UNAVAILABLE && restrictionOptions && restrictionOptions.useLexiconForFeature">
            mit deinem aktuellen finCraft Abo {{ groupPriceModel.id }} kannst du dieses Feature nicht verwenden. <br/>
            Um
            <fin-lexicon-text :text="priceModelDescription(featureId)" auto-solve/>
            und zusätzliche finCraft Features zu nutzen, empfehlen wir ein
            Upgrade.
            <template v-if="isIosOrAndroidApp">
              Informiere dich auf <a :href="subscriptionWebUrl">fincraft.de</a> unter <em>Mein Profil –> Mein Abo</em>
              welche
              Möglichkeiten es gibt, um
              die
              erweiterte finCraft Funktionalität zu nutzen.
            </template>
            <template v-else>
              Buche unser Paket {{ nextPriceModel.id }} für {{ nextPriceModel.price.toLocaleString() }} € im
              Monat und es geht gleich weiter.
            </template>
          </p>

          <p v-else-if="restrictionType === featureRestrictions.UNAVAILABLE">
            mit deinem aktuellen finCraft Abo {{ groupPriceModel.id }} kannst du dieses Feature nicht verwenden. <br/>
            Um {{ priceModelDescription(featureId) }} und zusätzliche finCraft Features zu nutzen, empfehlen wir ein
            Upgrade.
            <template v-if="isIosOrAndroidApp">
              Informiere dich auf <a :href="subscriptionWebUrl">fincraft.de</a> unter <em>Mein Profil –> Mein Abo</em>
              welche
              Möglichkeiten es gibt, um die
              erweiterte finCraft Funktionalität zu nutzen.
            </template>
            <template v-else>
              Buche unser Paket {{ nextPriceModel.id }} für {{ nextPriceModel.price.toLocaleString() }} € im
              Monat und es geht gleich weiter.
            </template>
          </p>

          <template v-if="restrictionType === featureRestrictions.QUANTITY">
            <p v-if="nextPriceModel && nextPriceModel.id !== groupPriceModel.id">
              mit deinem aktuellen finCraft Abo {{ groupPriceModel.id }} kannst du {{ currentLimit }}
              {{ currentLimit === 1 ? featureIds[featureId].singular : featureIds[featureId].plural }} verwenden. <br/>
              Um weitere {{ featureIds[featureId].plural }} und zusätzliche finCraft Features zu nutzen, empfehlen wir
              ein Upgrade.
              <template v-if="isIosOrAndroidApp">
                Informiere dich auf <a :href="subscriptionWebUrl">fincraft.de</a> unter <em>Mein Profil –> Mein Abo</em>
                welche
                Möglichkeiten es gibt, um die
                erweiterte finCraft Funktionalität zu nutzen.
              </template>
              <template v-else>
                Buche unser Paket {{ nextPriceModel.id }} für {{ nextPriceModel.price.toLocaleString() }} € im
                Monat und es geht gleich weiter.
              </template>
            </p>

            <p v-else>
              dein Abo erlaubt dir die Nutzung von {{ currentLimit }}
              {{ currentLimit === 1 ? featureIds[featureId].singular : featureIds[featureId].plural }}. <br/>
              Um neue {{ featureIds[featureId].plural }} zu erstellen, musst du vorhandene
              {{ featureIds[featureId].plural }} deaktivieren oder löschen.
            </p>
          </template>

          <p v-if="restrictionType === featureRestrictions.QUALITY">
            mit deinem aktuellen finCraft Abo {{ groupPriceModel.id }} kannst du dieses Feature nicht vollständig
            verwenden. <br/>
            Um erweiterte Funktionen von {{ priceModelDescription(featureId) }} und zusätzliche finCraft Features zu
            nutzen, empfehlen wir ein Upgrade.
            <template v-if="isIosOrAndroidApp">
              Informiere dich auf <a :href="subscriptionWebUrl">fincraft.de</a> unter <em>Mein Profil –> Mein Abo</em>
              welche
              Möglichkeiten es gibt, um die
              erweiterte finCraft Funktionalität zu nutzen.
            </template>
            <template v-else>
              Buche unser Paket {{ nextPriceModel.id }} für
              {{ nextPriceModel.price.toLocaleString() }} € im Monat und es geht gleich weiter.
            </template>
          </p>

          <p v-if="restrictionType === featureRestrictions.INACTIVE && maxActiveElements">
            diese(s) {{ inactiveElement(true) }} ist inaktiv. Dein Abo erlaubt dir derzeit die Nutzung von
            {{ maxActiveElements }} {{ maxActiveElements === 1 ? inactiveElement(true) : inactiveElement(false) }}. Vor
            der aktiven Nutzung, musst du andere {{ inactiveElement(false) }} deaktivieren oder löschen.
          </p>

          <p v-if="restrictionType === featureRestrictions.INACTIVE && maxActiveElements === null">
            mit deinem aktuellen finCraft Abo {{ groupPriceModel.id }} kannst du dieses Feature nicht verwenden. <br/>
            Um {{ priceModelDescription(featureId) }} und zusätzliche finCraft Features zu nutzen, empfehlen wir ein
            Upgrade.
            <template v-if="isIosOrAndroidApp">
              Informiere dich auf <a :href="subscriptionWebUrl">fincraft.de</a> unter <em>Mein Profil –> Mein Abo</em>
              welche
              Möglichkeiten es gibt, um die
              erweiterte finCraft Funktionalität zu nutzen.
            </template>
            <template v-else>
              Buche unser Paket {{ nextPriceModel.id }} für {{ nextPriceModel.price.toLocaleString() }} € im
              Monat und es geht gleich weiter.
            </template>
          </p>
        </v-col>

        <v-col v-if="nextPriceModel"
               :class="$vuetify.breakpoint.smAndUp ? 'img-col d-flex justify-center' : 'd-flex justify-center'"
               cols="12"
               sm="3">
          <v-img :max-width="$vuetify.breakpoint.xsOnly ? '130px' : '120px'"
                 :src="require('@/assets/subscription/upgrade.svg')"
                 contain
          />
        </v-col>
      </v-row>

      <v-row v-if="groupPriceModel && !isIosOrAndroidApp">
        <v-col align="right" cols="12">
          <v-btn id="overview-btn" v-if="groupPriceModel" class="mr-2" text @click="navigateToProfile(undefined)">
            Überblick Preismodell
          </v-btn>
          <v-btn id="upgrade-btn" v-if="groupPriceModel && groupPriceModel.nextPriceModel" dark
                 @click="navigateToProfile(groupPriceModel.nextPriceModel)">
            Abo Upgrade
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="!groupPriceModel">
        <v-col>
          <p>
            Ein Fehler ist aufgetreten. Wende dich bitte an den finCraft-Support <a href="mailto:support@fincraft.de">support@fincraft.de</a>
            mit der Information, dass deinem Benutzer kein Preismodell zugeordnet ist.
          </p>
        </v-col>
      </v-row>
    </template>
  </fin-data-loader>
</template>

<script>
import FinCurrentUserName from "@/components/auth/CurrentUserName"
import FinDataLoader from "@/components/common/DataLoader"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import PriceModel from "@/mixins/PriceModel"
import {mapGetters} from "vuex"
import DataFetcher from "@/components/common/DataLoader/DataFetcher"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getPriceModelForPermission} from "@/components/common/subscription/graphql"
import FinLexiconText from "@/components/common/lexicon/LexiconText"
import Stripe from "@/mixins/Stripe"
import finBrowser from "@/js/finBrowser"
import BaseUrl from "@/mixins/BaseUrl"

export default {
  name: "FinSubscriptionContent",
  components: {FinLexiconText, FinDataLoader, FinCurrentUserName},
  props: {
    /** The resolver to load the next price model for the missing feature id / limit / levels */
    nextPriceModelResolver: {},
    /** The feature id, see @/js/finPriceModel */
    featureId: {
      type: String,
      required: true,
    },
    /** The restriction type, see @/js/finPriceModel */
    restrictionType: {
      type: String,
    },
    /** Set additional resitrctions e.g. QUANTITY => itemAmount, QUALITY => level etc. */
    restrictionOptions: {
      type: Object,
      default: null
    },
    /** For displaying the inactive message the maximum number of allowed active elements has to be set */
    maxActiveElements: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      nextPriceModel: null,
      featureIds: PRICEMODEL_FEATURE_IDS,
      featureRestrictions: PRICEMODEL_FEATURE_RESTRICTIONS,
      isIosOrAndroidApp: finBrowser.IS_IOS_OR_ANDROID_APP,
      subscriptionWebUrl: undefined
    }
  },
  mixins: [PriceModel, Stripe, BaseUrl],
  computed: {
    ...mapGetters('auth', ['groupPriceModel', 'allPriceModels']),
    dialogTitle() {
      if (!this.groupPriceModel) {
        return "Technischer Fehler"
      } else if (this.isIosOrAndroidApp && this.groupPriceModel.nextPriceModel) {
        return "Informiere dich über ein Upgrade!"
      } else if (!this.isIosOrAndroidApp && this.groupPriceModel.nextPriceModel) {
        return "Abo Upgrade?"
      } else {
        return "Limit erreicht!"
      }
    },
    currentLimit() {
      return this.priceModelEnabledAndLimit(this.featureId)
    },
    queryVars() {
      const queryVars = {
        featureId: this.featureId
      }
      if (this.restrictionType === PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY && this.restrictionOptions?.itemAmount) {
        queryVars.itemAmount = this.restrictionOptions.itemAmount
      }
      if (this.restrictionType === PRICEMODEL_FEATURE_RESTRICTIONS.QUALITY && this.restrictionOptions?.level) {
        queryVars.level = this.restrictionOptions.level
      }

      return queryVars
    },
  },
  methods: {
    async loadData() {
      if (this.nextPriceModelResolver) {
        this.nextPriceModel = await DataFetcher.fetchData(this.nextPriceModelResolver)
      } else {
        if (this.restrictionOptions && this.restrictionOptions.visibleFrom) {
          this.nextPriceModel = this.allPriceModels.find(apm => apm.id === this.restrictionOptions.visibleFrom)
        } else {
          let result = await API.graphql(graphqlOperation(getPriceModelForPermission, this.queryVars))
          this.nextPriceModel = result.data.getPriceModelForPermission
        }
      }
    },
    navigateToProfile(abo) {
      // click on abo update in the dialog
      if (abo) {
        if (this.groupPriceModel.id === 'BASIC') {
          // navigate to the upgrading view under mein Abo
          this.$emit('changeSubscriptionClicked')
          this.$router.push({
            name: `myProfile`,
            params: {tab: 'subscription'},
            query: {changeToAboId: abo.id}
          })
        } else {
          // navigate to stripe
          this.navigateToStripeChangeAbo(undefined, abo.id, undefined)
        }
      } else {
        // show abos' overview
        this.$emit('showSubscriptionsClicked')
        this.$router.push({
          name: 'myProfile',
          params: {tab: 'subscription'}
        })
      }
    },
    inactiveElement(singular) {
      const element = PRICEMODEL_FEATURE_IDS[this.featureId]
      return (singular ? element?.singular : element?.plural) || element.id.charAt(0).toUpperCase() + element.id.slice(1).toLowerCase()
    }
  },
  mounted() {
    this.subscriptionWebUrl = this.getBaseURL() + "/protected/myProfile/subscription"
  }
}
</script>

<style lang="scss" scoped>
h2 {
  color: var(--night-blue) !important;
  font-family: $body-font-family;
  font-weight: 700;
  font-size: 20px !important;
  padding-top: 18px;
  padding-bottom: 18px;
}
</style>
